var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.254 11.804c-.29.427-.809 1.192.103 1.843.592.37 2.295 0 2.813-3.406.518-3.405-.444-6.292-2.443-7.921-2-1.63-2.517-1.408-2.591-1.112-.05.198.214.4.472.598.129.098.256.196.342.29 1.403 1.552 1.628 2.366 2.216 4.5l.005.017c.594 2.147-.591 4.665-.813 5.035a3.61 3.61 0 0 1-.103.156zm-6.71-8.226c.53-.794.983-1.285 1.307-1.636.13-.14.24-.258.324-.363.296-.372-.518-.298-1.11-.001-.398.197-.764.404-2.074 1.775-1.555 1.63-3.184 5.48-.74 9.552 1.414 2.357 3.065 3.214 4.765 4.095.974.505 1.964 1.019 2.935 1.828 2.665 2.221 2.591 4.517 2.443 6.738-.118 1.765-1.732 3.438-2.539 4.272-.208.216-.362.375-.422.466-.296.445-.148.74.296.593.444-.15 4.442-2.519 4.738-6.887.297-4.368-2.517-6.886-4.22-8.145-.481-.355-1.086-.67-1.74-1.01-1.662-.862-3.64-1.888-4.702-4.172-1.48-3.184-.276-5.583.74-7.108zm-.129 16.618c-.04.059-.075.111-.102.156-.222.37-1.406 2.888-.814 5.035l.003.016c.59 2.135.814 2.95 2.217 4.5.086.095.213.193.342.291.258.198.522.4.472.598-.074.296-.592.518-2.59-1.11-2-1.63-2.963-4.517-2.444-7.923.518-3.407 2.22-3.777 2.813-3.407.912.65.392 1.416.102 1.843z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgix);
export default __webpack_public_path__ + "static/media/AGIX.67bd6f8e81ae70b6dddd44dd5e6eaf38.svg";
export { ForwardRef as ReactComponent };